import Vue from 'vue'
import App from './App.vue'
import router from './route/router.js'
import modal from "@/utils/modal";
import '@/assets/styles/style_common.css'
import vueToTop from 'vue-totop'
import BaiduMap from 'vue-baidu-map'

import {
    ActionSheet,
    Button,
    Cell,
    CellGroup,
    Col,
    Dialog,
    Field,
    Form,
    GoodsAction,
    GoodsActionButton,
    GoodsActionIcon,
    Image as VanImage,
    List,
    Picker,
    Popup,
    PullRefresh,
    Radio,
    RadioGroup,
    Row,
    Step,
    Steps,
    Swipe,
    SwipeItem,
    Tab,
    Tabbar,
    TabbarItem,
    Tabs,
    Uploader
} from 'vant';
import store from "@/store";
import {convertImg} from "@/utils/jiutang";

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'C4Y906kyCFYBYneHjOIAdqaaacM0qFjB'
})

Vue.use(vueToTop)

Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Vue.config.productionTip = false
// 模态框对象
Vue.prototype.$modal = modal
Vue.prototype.convertImg = convertImg
const arr = [
    Dialog, List, PullRefresh, Button, Cell, CellGroup, Tabbar, TabbarItem, Swipe, SwipeItem, VanImage, Col, Row, Tab, Tabs, Step, Steps, GoodsAction, GoodsActionIcon, GoodsActionButton, Popup, Field, RadioGroup, Radio, Form, Uploader, Picker, ActionSheet
]
arr.forEach(item => Vue.use(item))
new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
